module.exports = __webpack_public_path__ + "img/ProColombia_Logo_Vertical.74e20112.png";